import {
  getDayRangeForAnchor,
  getDefaultDayRange,
} from '@/features/layouts/collection/group/day.dateRange';
import type { TemplateMeta } from '../../types';
import { WeekIcon } from '../plannerWeek/Icon';

export const dayByCategoryMeta: TemplateMeta = {
  name: 'Day by Category',
  orientation: 'landscape',
  Icon: WeekIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Day',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'date-range',
  getDefaultRange: getDefaultDayRange,
  getRangeForAnchor: getDayRangeForAnchor,
};
